export default "__VITE_ASSET__CFoaQx_O__"